"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_1 = require("@pulse-smart-components-kit/common");
const datepicker_1 = require("@pulse-web-ui/datepicker");
const helper_text_1 = require("@pulse-web-ui/helper-text");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const i18n_1 = require("../../i18n");
const calendar_style_1 = require("./calendar.style");
const insurance_period_type_1 = require("../../insurance-period.type");
const Calendar = ({ value, onChange, error, yearPolicy, startDate, endDate, maxEndDate, onAnalyticEventSend, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [isOpenEndDateCalendar, setIsOpenEndDateCalendar] = (0, react_1.useState)(false);
    const [isOpenStartDateCalendar, setIsOpenStartDateCalendar] = (0, react_1.useState)(false);
    const startDateCalendarRef = (0, react_1.useRef)(null);
    const endDateCalendarRef = (0, react_1.useRef)(null);
    const minStartDate = (0, react_1.useMemo)(() => (0, common_1.convertDateByTimeZoneStrict)(new Date(startDate)), [startDate]);
    const maxStartDate = (0, react_1.useMemo)(() => {
        const defaultMaxDate = new Date(endDate);
        return (0, common_1.convertDateByTimeZoneStrict)(value?.end && value?.end < defaultMaxDate ? value.end : defaultMaxDate);
    }, [value?.end, endDate]);
    const toggleOpenEndDateCalendar = () => {
        setIsOpenEndDateCalendar((prev) => !prev);
    };
    const toggleOpenStartDateCalendar = () => {
        setIsOpenStartDateCalendar((prev) => !prev);
    };
    const handleSendDatesAnalytics = (selectedDate) => {
        if (selectedDate) {
            onAnalyticEventSend &&
                onAnalyticEventSend(insurance_period_type_1.InsurancePeriodAnalyticEvent.ON_DATES_SELECT);
        }
    };
    const handleStartDate = (0, react_1.useCallback)((date) => {
        const end = value?.end;
        onChange({
            ...value,
            start: date,
        });
        if (startDateCalendarRef?.current?.setOpen && date) {
            startDateCalendarRef.current.setOpen(false);
        }
        if (endDateCalendarRef?.current?.setOpen && date && !end) {
            endDateCalendarRef.current.setOpen(true);
            endDateCalendarRef.current.setFocus();
        }
        handleSendDatesAnalytics(end);
    }, [value, endDateCalendarRef.current, yearPolicy]);
    const handleEndDate = (0, react_1.useCallback)((date) => {
        onChange({
            ...value,
            end: date,
        });
        if (endDateCalendarRef?.current?.setOpen && date) {
            endDateCalendarRef.current.setOpen(false);
        }
        if (startDateCalendarRef?.current?.setOpen && date && !value?.start) {
            startDateCalendarRef.current.setOpen(true);
            startDateCalendarRef.current.setFocus();
        }
        handleSendDatesAnalytics(minStartDate);
    }, [value, minStartDate, startDateCalendarRef.current]);
    const insuranceMinDateForEnd = (0, react_1.useMemo)(() => {
        const minDate = new Date(value?.start || startDate);
        return minDate.getTime() < minStartDate.getTime() ? minStartDate : minDate;
    }, [value?.start, startDate, minStartDate]);
    const fieldStatus = error ? 'error' : 'default';
    return ((0, jsx_runtime_1.jsxs)(calendar_style_1.CalendarStyle, { children: [(0, jsx_runtime_1.jsx)(calendar_style_1.CalendarItem, { children: (0, jsx_runtime_1.jsx)(helper_text_1.HelperText, { noMargin: true, status: fieldStatus, message: error?.start?.message, children: (0, jsx_runtime_1.jsx)(datepicker_1.Datepicker, { onCalendarOpen: toggleOpenStartDateCalendar, onCalendarClose: toggleOpenStartDateCalendar, ref: startDateCalendarRef, disabledKeyboardNavigation: true, showInput: true, minDate: minStartDate, maxDate: maxStartDate, selected: value?.start, onChange: handleStartDate, label: t('SMART:InsurancePeriod.labels.startPolicy', {
                            defaultValue: i18n_1.i18nDefaultValues.InsurancePeriod.labels.startPolicy,
                        }), error: !isOpenStartDateCalendar && !!error?.start }) }) }), (0, jsx_runtime_1.jsx)(calendar_style_1.CalendarItem, { children: (0, jsx_runtime_1.jsx)(helper_text_1.HelperText, { noMargin: true, status: fieldStatus, message: error?.end?.message, children: (0, jsx_runtime_1.jsx)(datepicker_1.Datepicker, { onCalendarOpen: toggleOpenEndDateCalendar, onCalendarClose: toggleOpenEndDateCalendar, disabledKeyboardNavigation: true, showInput: true, ref: endDateCalendarRef, minDate: insuranceMinDateForEnd, onChange: handleEndDate, selected: value?.end, label: t('SMART:InsurancePeriod.labels.endPolicy', {
                            defaultValue: i18n_1.i18nDefaultValues.InsurancePeriod.labels.endPolicy,
                        }), maxDate: maxEndDate, error: !isOpenEndDateCalendar && !!error?.end, openToDate: value?.end || insuranceMinDateForEnd }) }) })] }));
};
exports.Calendar = Calendar;
